import { useAppSelector } from "../app/hooks";
import useMembers from "../hooks/use-members";
import * as BiometricDeviceSlice from "../features/biometric-device/biometric-device.slice";
import Loader from "../components/loader";
import useBiometricTransactions from "../hooks/use-biometric-transactions";
import { useParams } from "react-router";
import useUsers from "../hooks/use-users";
import BiometricTransactionTable from "../features/biometric-transaction/components/biometric-transaction-table";

const BiometricTransactions = () => {
    const { deviceId } = useParams<{ deviceId: string }>();
    const isLoading = useAppSelector(BiometricDeviceSlice.selectIsLoading);

    const [biometricTransactions] = useBiometricTransactions(deviceId ? Number(deviceId) : undefined);
    const [members] = useMembers();
    const [users] = useUsers();

    return (
        <div>
            {isLoading &&
                <Loader />
            }
            {biometricTransactions &&
                <BiometricTransactionTable transactions={biometricTransactions} deviceId={Number(deviceId)} />
            }
        </div>
    )
}

export default BiometricTransactions;